// @flow
import React from "react";
import { Route, Switch, Redirect } from "react-router";
import Home from "../containers/home/Home";
import Products from "../containers/products/Products";
import OrdersV2 from "../containers/ordersV2/Orders";
import Orders from "../containers/orders/Orders";
import Statements from "../containers/statements/Statements";
import Reports from "../containers/reports/Reports";
import Settings from "../containers/settings/Settings";
import Transfers from "../containers/transfers/Transfers";
import Inventory from "../containers/inventory/Inventory";
import StockRequest from "../containers/stockRequest/StockRequest";
import Sales from "../containers/sales/Sales";
import { EmptyResults } from "../components/common";
import Imports from "../containers/imports/Imports";
import Notifications from "../containers/notifications/Notifications";
import Disputes from "../containers/disputes/Disputes";

const Routes = (
  <Switch>
    <Route exact path="/:locale/" component={Home} />
    <Route exact path="/:locale/orders" component={OrdersV2} />
    <Redirect from="/:locale/orders-beta" to="/orders" />
    <Redirect from="/:locale/orders/:poNr" to="/orders" />

    <Route exact path="/:locale/statements" component={Statements} />
    <Route
      exact
      path="/:locale/statements/:statementNr"
      component={Statements}
    />

    <Route exact path="/:locale/inventory" component={Inventory} />

    <Route exact path="/:lang/notifications" component={Notifications} />
    <Route exact path="/:lang/disputes" component={Disputes} />
    <Route exact path="/:lang/disputes/:key" component={Disputes} />
    <Route exact path="/:lang/disputes/ticket/:ticketNr" component={Disputes} />

    <Route exact path="/:locale/products" component={Products} />
    <Route exact path="/:locale/products/o/:offerCode" component={Products} />
    <Route exact path="/:locale/products/sku/:sku" component={Products} />
    <Route exact path="/:locale/products/:key" component={Products} />

    <Route exact path="/:locale/stock-request" component={StockRequest} />
    <Route exact path="/:locale/sales" component={Sales} />
    <Route exact path="/:locale/sales/:salesItemNr" component={Sales} />
    <Route
      exact
      path="/:locale/stock-request/picklist/:picklistNr"
      component={StockRequest}
    />

    <Route exact path="/:locale/reports" component={Reports} />

    <Route exact path="/:locale/settings" component={Settings} />
    <Route exact path="/:locale/transfers" component={Transfers} />
    <Route exact path="/:locale/transfers/asn/:asn" component={Transfers} />
    <Route
      exact
      path="/:locale/transfers/fbn-asn/:fbnAsn"
      component={Transfers}
    />
    <Route exact path="/:locale/transfers/rtv/:rtv" component={Transfers} />
    <Route exact path="/:locale/transfers/:key" component={Transfers} />
    <Route
      exact
      path="/:locale/transfers/preview/:previewAsn"
      component={Transfers}
    />
    <Route path="/:locale/" component={EmptyResults} />
  </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/Routes.js